import { CONSTANTS } from '../_data/lookups.js';
export function extractToolStepsFromStep(step, order = {}) {
    const { branchCaseOrder = 'when-what', loopCaseOrder = 'what-when', } = order;
    if (step.stepKind === CONSTANTS.Enums.StepKind.tool) {
        return [step];
    }
    if (step.stepKind === CONSTANTS.Enums.StepKind.branch) {
        const branchStep = step;
        const cases = branchStep.cases ?? [];
        return cases.flatMap((stepCase) => {
            if (branchCaseOrder === 'what-when') {
                return [stepCase.what, stepCase.when];
            }
            return [stepCase.when, stepCase.what];
        });
    }
    if (step.stepKind === CONSTANTS.Enums.StepKind.while) {
        const whileStep = step;
        if (loopCaseOrder === 'when-what') {
            return [whileStep.case.when, whileStep.case.what];
        }
        return [whileStep.case.what, whileStep.case.when];
    }
    if (step.stepKind === CONSTANTS.Enums.StepKind.for) {
        const forStep = step;
        if (loopCaseOrder === 'when-what') {
            return [forStep.case.when, forStep.case.what];
        }
        return [forStep.case.what, forStep.case.when];
    }
    return [];
}
